export default __webpack_public_path__ + "static/media/Remove-Box.274fa031.svg";